import { Col, Flex, Row } from 'antd';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import useTenant from 'src/stores/tenant/tenant.store';
import CONTANTS from 'src/utils/constants';
import FUNCS from 'src/utils/func';

function ChooseTenant({ onSelectTenant }: { onSelectTenant: (id: number) => void }) {
  const { listTenant } = useTenant();

  return (
    <div style={{ padding: '20px 50px' }}>
      <Row justify="space-between" style={{ marginBottom: 4 }} align="middle">
        <h3>Chọn ứng dụng</h3>
        {/* <div>{props.renderRight}</div> */}
      </Row>
      <Row gutter={16}>
        {listTenant.map((i) => {
          return (
            <Col span={6} key={i.id}>
              <div className="card-custom" style={{ cursor: 'pointer' }} onClick={() => onSelectTenant(i.id)}>
                <Flex>
                  <img src={FUNCS.getFullUrl(i.logo) || CONTANTS.FALLBACK_IMG} alt="" width={40} height={40} />
                  <div style={{ marginLeft: 8 }}>
                    <div>
                      <strong>{i.name}</strong>
                    </div>
                    <Link to={i.site || ''} target="_blank" rel="noopener noreferrer">
                      {i.site}
                    </Link>
                  </div>
                </Flex>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

export default memo(ChooseTenant);
